(() => {
  if (customElements.get('banner-swiper')) {
    return;
  }

  class BannerSwiper extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.contentSlider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initMainSlider();
    }

    initMainSlider() {
      this.options = {
        slidesPerView: 1,
        loop: true,
        watchSlidesProgress: true,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        },
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('banner-swiper', BannerSwiper);
})();